module.exports = __webpack_public_path__ + "img/alertNavIcon.4d4eac9d.svg";